import { FormType } from '../../../form-types';
import { MicroGlp1FollowupFieldAnswers } from './questions';

const microGlp1Followup: FormType<MicroGlp1FollowupFieldAnswers> = {
  name: 'GIP/GLP-1 Microdosing Followup',
  questions: [
    'microGlp1Followup_sex',
    'microGlp1Followup_weightAndHeight2025',
    {
      key: 'microGlp1Followup_healthChanges',
      next: {
        condition: { 'microGlp1Followup_healthChanges.yes': true },
        key: 'microGlp1Followup_healthChangesDetails',
        els: 'microGlp1Followup_medicationResponse'
      }
    },
    'microGlp1Followup_healthChangesDetails',
    {
      key: 'microGlp1Followup_medicationResponse',
      next: {
        condition: { 'microGlp1Followup_medicationResponse.not_well': true },
        key: 'microGlp1Followup_medicationIssues',
        els: 'microGlp1Followup_sideEffects'
      }
    },
    'microGlp1Followup_medicationIssues',
    {
      key: 'microGlp1Followup_sideEffects',
      next: {
        condition: { 'microGlp1Followup_sideEffects.yes': true },
        key: 'microGlp1Followup_sideEffectsDetails',
        els: 'microGlp1Followup_additionalQuestions'
      }
    },
    'microGlp1Followup_sideEffectsDetails',
    'microGlp1Followup_additionalQuestions',
    {
      key: 'microGlp1Followup_consentTruthfulness',
      next: {
        condition: {
          'microGlp1Followup_consentTruthfulness.non_consent': true
        },
        key: 'microGlp1Followup_didNotConsent',
        els: 'microGlp1Followup_consentTreatment'
      }
    },
    {
      key: 'microGlp1Followup_consentTreatment',
      next: {
        condition: { 'microGlp1Followup_consentTreatment.non_consent': true },
        key: 'microGlp1Followup_didNotConsent',
        els: 'microGlp1Followup_complete'
      }
    },
    'microGlp1Followup_complete',
    'microGlp1Followup_ineligible',
    'microGlp1Followup_didNotConsent'
  ]
};
export default microGlp1Followup;
